<h1 class="pl-4">Wnioski elektroniczne</h1>
<app-email-verify-info [beneficiary]="beneficiary()"></app-email-verify-info>
@if (applicationContextService.isBeneficiaryContext()) {
  <ng-container *ngTemplateOutlet="lastUsedApplicationsTmpl"></ng-container>
  <div class="flex flex-col gap-4 p-4">
    <h2 class="application-cards-title">Dla świadczeniobiorców</h2>
    <div class="flex gap-2 flex-wrap">
      @for (item of SWIADCZENIOBIORCY_FILTERS; track item) {
        <p-button
          [styleClass]="
            'customInfoButton bold-focus' +
            (filter() !== item.value ? ' outlined silver' : '')
          "
          size="small"
          iconPos="right"
          [icon]="filter() === item.value ? 'pi pi-times' : ''"
          (click)="toggleFilter(item.value)"
          [label]="item.label"
        />
      }
    </div>
  </div>
  <div class="flex flex-col gap-4 p-4">
    <h2 class="application-cards-title">Dla przedsiębiorców</h2>
    <div class="flex gap-2 flex-wrap">
      @for (item of PRZEDSIEBIORCY_FILTERS; track item) {
        <p-button
          [styleClass]="
            'customInfoButton bold-focus' +
            (filter() !== item.value ? ' outlined silver' : '')
          "
          iconPos="right"
          size="small"
          [icon]="filter() === item.value ? 'pi pi-times' : ''"
          (click)="toggleFilter(item.value)"
          [label]="item.label"
        />
      }
    </div>
  </div>
  @if (this.filter()) {
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header class="accordionHeaderMainApplications">
          <div>{{ filter() | getApplicationCategoryName }}</div>
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
            #filteredApplicationsEl
          >
            @for (application of filteredApplications; track application.id) {
              <button
                class="custom-box"
                (click)="initApplicationFlow(application)"
                (keydown.enter)="initApplicationFlow(application)"
              >
                <app-application-accordion-card
                  [application]="application"
                  class="h-full"
                />
              </button>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  }
  <p-accordion [value]="lastUsedApplicationsAccordionValue()">
    <p-accordion-panel value="0">
      <p-accordion-header
        class="accordionHeaderMainApplications clear-accordion-bottom-border"
      >
        <div>Najczęściej wybierane wnioski</div>
      </p-accordion-header>
      <p-accordion-content>
        <div
          class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
        >
          @for (
            application of applications()?.mostUsedApplications;
            track application.id
          ) {
            <button
              class="custom-box"
              (click)="initApplicationFlow(application)"
              (keyup.enter)="initApplicationFlow(application)"
            >
              <app-application-accordion-card
                [application]="application"
                class="h-full"
              />
            </button>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
} @else {
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header
        class="accordionHeaderMainApplications clear-accordion-bottom-border"
      >
        <div>Opieka nad dzieckiem do lat 3 (Rejestr Żłobków)</div>
      </p-accordion-header>
      <p-accordion-content>
        <div class="mt-2">
          <app-info-message [labelHTML]="manualInfoMessageContent" />
        </div>
        <div
          class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 mt-6"
        >
          @for (application of orgBabyApplications(); track application.id) {
            <button
              class="custom-box"
              (click)="initApplicationFlow(application)"
              (keyup.enter)="initApplicationFlow(application)"
            >
              <app-application-accordion-card
                [application]="application"
                class="h-full"
              />
            </button>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header
        class="accordionHeaderMainApplications clear-accordion-bottom-border"
      >
        <div>Turnusy Rehabilitacyjne (Rejestry)</div>
      </p-accordion-header>
      <p-accordion-content>
        <div
          class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
        >
          @for (application of orgTurnusyApplications(); track application.id) {
            <button
              class="custom-box"
              (click)="initApplicationFlow(application)"
              (keyup.enter)="initApplicationFlow(application)"
            >
              <app-application-accordion-card
                [application]="application"
                class="h-full"
              />
            </button>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
}

<ng-template #lastUsedApplicationsTmpl>
  @if (lastUsedApplicationService.lastUsedApplications().length > 0) {
    <p-accordion value="0">
      <p-accordion-panel value="0" class="accordion-panel">
        <p-accordion-header
          class="accordionHeaderLastApplications clear-accordion-bottom-border"
          >Ostatnio składane wnioski
        </p-accordion-header>
        <p-accordion-content>
          <div
            class="grid grid-cols-2 max-[30rem]:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
          >
            @for (
              application of lastUsedApplicationService.lastUsedApplications();
              track application.id
            ) {
              <button
                class="custom-box"
                (click)="initApplicationFlow(application)"
                (keyup.enter)="initApplicationFlow(application)"
              >
                <app-application-accordion-card
                  [application]="application"
                  class="h-full"
                />
              </button>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  }
</ng-template>
